module.exports = __webpack_public_path__ + "img/9788960515642.6e2c2efa.jpg";